import React, { useEffect, useState } from 'react';

// tracks the tab/window change and updates the state
const useTrackTabChange = () => {
    const [isTabVisible, setIsTabVisible] = useState(false);
    useEffect(() => {
        function onWindowChange(e: any) {
            setIsTabVisible(document.visibilityState !== 'hidden');
        }
        document.addEventListener('visibilitychange', onWindowChange);
        return () => {
            document.removeEventListener('visibilitychange', onWindowChange);
        };
    }, []);
    return isTabVisible;
};

export default useTrackTabChange;
